import { Grid } from '@mui/material';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import './guarantorCard.css';
import CustomisedButton from '../../button/button';
import { IGuarantorEditCard } from './IGuarantorCard';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { IDeleteGuarantorRequest } from '../../../models/guarantor.model';
import { useMutation } from 'react-query';
import { deleteGuarantor } from '../../../services/guarantor.service';
import { setGuarantorInfo } from '../../../redux/guarantor/guarantorInfoSlice';
import { useDispatch } from 'react-redux';
import ConfirmDeleteModal from '../../modal/confirmDeleteModal';
import { useEffect, useState } from 'react';

export default function GuarantorEditCard({
    firstName,
    lastName,
    nationalCode,
    backgroundColor,
    title,
    referenceKey,
    setChildValue,
    guarantorKey,
    setIsDelete,
    mobileNumber,
    setIsEditDocument,
    setIsEditCheque,
    isAdditionalInfoCompleted,
    isCompleted,
    entityRejectReasons,
    documentTypeRejectReasons,
    checkBySetad,
    formCheckBySetad,
    rejectReasonsKey,
    isCheckedBySetad
}: IGuarantorEditCard) {
    const dispatch = useDispatch();
    const [openVerifyModal, setOpenVerifyModal] = useState(false);
    const [confirm, setConfirm] = useState(false);
    useEffect(() => {
        if (confirm === true) {
            removeDocument();
        }
    }, [confirm])
    function removeDocument() {
        const deleteGuarantor = {} as IDeleteGuarantorRequest;
        deleteGuarantor.key = guarantorKey!;
        deleteGuarantor.referenceKey = referenceKey!;
        DeleteGuarantorMutate(deleteGuarantor);
    }
    function deleteImage() {
        setOpenVerifyModal(true);
    }
    function clickEditDocument() {
        if ((documentTypeRejectReasons!.length > 0 && checkBySetad!.length > 0) || checkBySetad!.length === 0) {
            dispatch(setGuarantorInfo({ title, guarantorKey }));
            setIsEditDocument(true);
        }
    }
    function clickEditCheque() {
        if ((entityRejectReasons!.length > 0 && checkBySetad!.length > 0) || checkBySetad!.length === 0) {
            dispatch(setGuarantorInfo({ title, guarantorKey }));
            setIsEditCheque(true);
        }
    }
    const { mutate: DeleteGuarantorMutate } = useMutation(
        deleteGuarantor,
        {
            onSuccess: (data: boolean) => {
                setIsDelete(true);
            },
        }
    );
    return (
        <>
            <Grid
                className={'borderColorPrimaryColorLight-300'}
                style={{
                    border: '1.5px solid ',
                    height: 'fit-content',
                    borderRadius: '5px',
                    background: '#fff',
                    alignContent: 'center',
                    marginTop: '10px',
                    backgroundColor: entityRejectReasons!.length > 0 || documentTypeRejectReasons!.length > 0 || rejectReasonsKey!.length > 0
                        ? '#FBE4E7' : isCompleted ? '#DEF1F1' : backgroundColor,
                    minHeight: '110px',
                }}
                container
                spacing={0}
                xs={12}
            // onClick={() => onClick!()}
            >
                <Grid container item spacing={0} xs={12} style={{ margin: '20px', marginBottom: '10px' }}>
                    <div style={{ display: 'inline-block', width: '100%' }}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span style={{ fontSize: "14px", fontWeight: "bold" }} className={"text-sm " + "primaryColorLight-900"}>{title}</span>
                            <span className="font-normal text-xs primaryColorLight-900" style={{ float: "right", fontSize: "12.5px" }}>
                                {firstName + " " + lastName + " - " + "کدملی" + nationalCode}
                            </span>
                            {isCompleted && formCheckBySetad === true && isCheckedBySetad === true &&
                                entityRejectReasons!.length === 0 && documentTypeRejectReasons!.length === 0 && rejectReasonsKey!.length === 0
                                ? null :
                                <div >
                                    <hr
                                        style={{
                                            marginTop: '20px',
                                            marginBottom: '5px',
                                            border: `1px solid ${isCompleted || (entityRejectReasons!.length > 0 || checkBySetad!.length > 0 || rejectReasonsKey!.length > 0) ? '#fff' : '#D7DBEC'}`
                                        }}
                                    />
                                    <Grid container xs={12} style={{ textAlign: 'justify', paddingTop: '5px' }}>
                                        <Grid item xs={4} style={{
                                            borderLeft: `2px solid ${isCompleted || (entityRejectReasons!.length > 0 || checkBySetad!.length > 0) ? '#fff' : '#D7DBEC'}`,
                                            //  maxWidth: '30%',
                                            textAlign: 'center'
                                        }}>
                                            <div onClick={() => clickEditCheque()}>
                                                <EditOutlinedIcon style={{ color: `${(entityRejectReasons!.length === 0 && checkBySetad!.length > 0) ? 'var(--tirnary-text-color)' : 'var(--primary-text-color)'}` }} />
                                                <span style={{
                                                    fontSize: "12.5px", fontWeight: 'bold',
                                                    color: `${(entityRejectReasons!.length === 0 && checkBySetad!.length > 0) ? 'var(--tirnary-text-color)' : 'var(--primary-text-color)'}`
                                                }}>چک</span>
                                            </div>
                                        </Grid>
                                        <Grid item xs={4} style={{
                                            borderLeft: `2px solid ${isCompleted || (entityRejectReasons!.length > 0 || checkBySetad!.length > 0) ? '#fff' : '#D7DBEC'}`,
                                            //  maxWidth: '30%',
                                            textAlign: 'center'
                                        }}>
                                            <div onClick={() => clickEditDocument()}>
                                                <EditOutlinedIcon style={{ color: `${(documentTypeRejectReasons!.length === 0 && checkBySetad!.length > 0) ? 'var(--tirnary-text-color)' : 'var(--primary-text-color)'}` }} />
                                                <span style={{
                                                    fontSize: "12.5px", fontWeight: 'bold',
                                                    color: `${(documentTypeRejectReasons!.length === 0 && checkBySetad!.length > 0) ? 'var(--tirnary-text-color)' : 'var(--primary-text-color)'}`
                                                }}>مستندات</span>
                                            </div>
                                        </Grid>
                                        <Grid item xs={4} style={{
                                            // maxWidth: '30%',
                                            textAlign: 'center'
                                        }}>
                                            <div onClick={() => deleteImage()}>
                                                <DeleteOutlineOutlinedIcon />
                                                <span style={{ fontSize: "12.5px", fontWeight: 'bold' }}>ضامن</span>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>
                            }
                        </div>
                    </div>
                </Grid>

            </Grid>
            <ConfirmDeleteModal text={"آیا از حذف این مدرک اطمینان داید؟"}
                buttonTitle={'حذف'}
                delButton={true}
                openModal={openVerifyModal}
                setOpenVerifyModal={setOpenVerifyModal}
                setConfirm={setConfirm}
            />
        </>
    );
}


